import { useEffect, useState } from "react";
import logo from "../../assets/images/logo/BannerISFsmall.png";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { UseAuth } from "../../auth/AuthContext";
import ConfirmationLogout from "../Shared/ConfirmationLogout";
import { useAppStateContext } from "../../auth/AppStateContext";
import { BiDollar } from "react-icons/bi";
import ImgBellNotificationAdmin from "src/assets/images/bellnotification.gif";

import {
  classNames,
  formatCurrency,
  getCoinImage,
  getFrozenImage,
  getProfileDefaultImage,
  money,
} from "src/helpers/mixins";
import NavUserAdminNotification from "./NavUserAdminNotification";
import { MdOutlineLogout } from "react-icons/md";
import { Popover, Tooltip } from "antd";
import { BsBell } from "react-icons/bs";
import NotificationUserBody from "./NotificationUserBody";
import useQueryListNotification from "src/hooks/useQueryListNotification";
import { IoClose, IoMenu } from "react-icons/io5";
import APIService from "src/services/Api";
import NotificationAdminBody from "../Admin/NotificationAdminBody";
/* const CashierMovements = lazy(
  () => import("src/components/System/CoinsMovements")
); */
const NavUser = () => {
  const { t } = useTranslation();
  const { user, updateUserData } = UseAuth();
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [showNotificationUser, setShowNotificationUser] = useState<boolean>(false);
  const [showNotificationAdmin, setShowNotificationAdmin] = useState<boolean>(false);

  const { notificationList } = useQueryListNotification(0, user?.id || "");
  const {
    currentDollar,
    currentDollarFiat,
    fetchCurrentDollar,
    cashierCoins,
    frozenCoins,
    adminHouseCoins,
    fetchCashierCoins,
    fetchAdminHouseCoins,
    showMenuMovil,
    setShowMenuMovil,
    setNotifications,
    notifications,
  } = useAppStateContext();
  const navigate = useNavigate();

  const viewNotifications = async () => {
    setShowNotificationUser(true);
    if (notifications.some((n) => !n.seen)) {
      await APIService.systemViewNotifications({
        user: user?.id || "",
        type: "user",
      });
    }
    setNotifications(notificationList.map((n) => ({ ...n, seen: true })));
  };

  const handleVisitDolar = () => {
    if (user?.role === "cashier") {
      navigate("/cashier/dolar");
    }
  };

  useEffect(() => {
    if ((!currentDollar || currentDollar === "0") && (user?.role === "user" || user?.role === "cashier")) {
      fetchCurrentDollar();
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (user?.role === "cashier") {
      fetchCashierCoins(user?.id || "");
    } else if (user?.role === "admin") {
      fetchAdminHouseCoins();
    }
  }, [user]);

  useEffect(() => {
    if (!user?.verifiedIdentity) {
      const intervalId = window.setInterval(() => {
        updateUserData();
      }, 15000);
      return () => clearInterval(intervalId);
    } /* else {
      const intervalId = window.setInterval(() => {
        updateUserData();
      }, 20000);
      return () => clearInterval(intervalId);
    } */
  }, []);

  useEffect(() => {
    updateUserData();
  }, []);

  const tooltipUserImage = (
    <div className="flex flex-col items-center justify-start gap-2 py-2 ">
      <Link to={`/usuario/${user?.id}`} className="text-black hover:text-sky-500">
        <div>Perfil</div>
      </Link>
      <div
        onClick={() => setShowConfirmation(true)}
        className="cursor-pointer text-black flex items-center gap-4 hover:text-sky-500"
      >
        Cerrar sesión
        <MdOutlineLogout className="cursor-pointer" size={18} />
      </div>
      {/* <div>
          <Language />
        </div> */}
    </div>
  );

  return (
    <>
      <div>
        <ConfirmationLogout
          show={showConfirmation}
          cancel={() => setShowConfirmation(false)}
          confirm={() => navigate("/salir")}
        />
        {!showNotificationUser && !showNotificationAdmin && (
          <nav
            className="bg-white px-0 md:px-2 fixed rounded-md py-1 w-full border-b border-gray-100 border-1"
            style={{ zIndex: "1000" }}
          >
            <div className="container flex flex-row justify-between items-center w-full">
              <div className="block w-full" id="mobile-menu">
                <ul className="flex items-center mb-0 gap-1 sm:gap-6 md:mt-0 md:text-sm md:font-normal">
                  <li className="flex items-center w-fit">
                    <Link to="/inicio" className="flex items-center py-2">
                      <img alt="logo" className="w-24 lg:w-38 h-auto" src={logo} />
                    </Link>
                  </li>
                  {user?.role === "admin" && (
                    <li className="flex">
                      <Tooltip
                        title={<div className="text-black font-semibold">Presiona para ver detalle.</div>}
                        color="#fff"
                      >
                        <button
                          onClick={() => navigate("/admin/coins")}
                          className="w-max rounded-xl bg-white flex items-center gap-2 md:text-sm font-semibold cursor-pointer px-3 md:px-5 py-2.5 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 hover:bg-green-admin/5 relative overflow-hidden"
                          style={{
                            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                          }}
                        >
                          <div className="text-xs md:text-sm hidden lg:block text-green-admin font-medium relative z-10">Coins casa</div>
                          <div className="relative z-10">
                            <img src={getCoinImage()} alt="my coins" className="w-6 h-6 object-contain" />
                            <div className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-400 rounded-full border-2 border-white shadow-sm"></div>
                          </div>
                          <span className="text-green-admin font-bold text-sm relative z-10">{money(adminHouseCoins || 0)}</span>
                          
                          {/* Subtle gradient overlay */}
                          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                        </button>
                      </Tooltip>
                    </li>
                  )}
                  {user?.role === "cashier" && (
                    <li className="flex">
                      <Tooltip
                        title={<div className="text-black font-semibold">Presiona para ver detalle.</div>}
                        color="#fff"
                      >
                        <button
                          onClick={() => navigate("/cashier/movimientos")}
                          className="w-max rounded-md bg-[#ececec] flex items-center gap-0 md:gap-2 text-xs md:text-sm  font-semibold  cursor-pointer  px-1 md:px-4 py-1.5"
                        >
                          <div className="text-xs md:text-sm hidden md:block">ISFCoins</div>
                          <img src={getCoinImage()} alt="my coins" className="w-3 md:w-6" />
                          {formatCurrency(cashierCoins || 0, "USD")}
                        </button>
                      </Tooltip>
                    </li>
                  )}
                  {user?.role === "cashier" && (
                    <li className="flex">
                      <Tooltip
                        title={
                          <div className="text-black">
                            <span className="font-semibold">Coins Congelados</span>
                            <div>
                              Representa el dinero que has recibido. una vez completes el pago, serán descongelados.
                              esto asegura la integridad del flujo del dinero.
                            </div>
                          </div>
                        }
                        color="#fff"
                      >
                        <button
                          onClick={() => navigate("/cashier/movimientos")}
                          className="w-max rounded-md bg-[#ececec] flex items-center gap-2 text-xs md:text-sm  font-semibold  cursor-pointer  px-1 md:px-4 py-1.5 md:py-0.5"
                        >
                          <div className="text-xs md:text-sm hidden lg:block">Congelados</div>
                          <div className="relative">
                            <img
                              src={getFrozenImage()}
                              alt="my frozen coins"
                              className="w-3 md:w-8 z-20 relative opacity-80"
                            />
                            <img
                              src={getCoinImage()}
                              alt="my coins"
                              className="w-3 md:w-6 absolute top-0 md:top-1 right-0 md:right-1 z-10"
                            />
                          </div>
                          {formatCurrency(frozenCoins || 0, "USD")}
                        </button>
                      </Tooltip>
                    </li>
                  )}
                  {(user?.role === "cashier" || user?.role === "user") && (
                    <li className="flex">
                      <Tooltip
                        color="#fff"
                        title={
                          <div className="text-black font-semibold">
                            Precio dólar
                            <div className="font-normal">
                              Este monto representa el precio del dólar dentro de la plataforma.
                            </div>
                          </div>
                        }
                      >
                        <button
                          onClick={() => handleVisitDolar()}
                          className={classNames(
                            (currentDollar || 0) === 0 ? "bg-rose-300" : "",
                            "w-max rounded-md bg-[#ececec] flex items-center gap-1 text-xs md:text-sm  font-semibold  cursor-pointer px-2 py-1.5"
                          )}
                        >
                          <span className=" hidden lg:block">{t("changetoday")}</span>
                          <BiDollar className="hidden sm:block text-green-admin-light" size={22} />{" "}
                          {(currentDollarFiat || "usd").toUpperCase()} ${money(currentDollar)}
                        </button>
                      </Tooltip>
                    </li>
                  )}
                  <li className="flex gap-x-2   items-center">
                    {user?.role !== "admin" && (
                      <div
                        onClick={() => viewNotifications()}
                        className="relative rounded-full sm:px-2 sm:py-1 hover:bg-gray-300 cursor-pointer transition duration-500 ease-in-out transform hover:-translate-y-0  "
                      >
                        <div className="rounded-full">
                          {notifications.filter((n) => !n.seen).length > 0 && (
                            <span className="notification-quantity">{notifications.filter((n) => !n.seen).length}</span>
                          )}
                          {notifications.some((n) => !n.seen) ? (
                            <img src={ImgBellNotificationAdmin} className="w-10" alt="notificaciones" />
                          ) : (
                            <BsBell className="text-black text-base md:text-2xl" />
                          )}
                        </div>
                      </div>
                    )}
                    {user?.role === "admin" && (
                      <div>
                        <NavUserAdminNotification handleShowNav={setShowNotificationAdmin} />
                      </div>
                    )}
                    <div className="justify-center cursor-pointer flex flex-col items-center flex text-white font-semibold">
                      <Popover content={tooltipUserImage} trigger="click">
                        <div
                          className="w-5 h-5 sm:w-10 sm:h-10 bg-cover bg-center rounded-full"
                          style={{
                            backgroundImage: `url(${
                              (user?.photoUrl?.length || 0) > 0
                                ? process.env.REACT_APP_PROFILEPICTURE + (user?.photoUrl || "")
                                : getProfileDefaultImage()
                            })`,
                          }}
                        ></div>
                      </Popover>
                    </div>
                    <div className="flex md:hidden">
                      {((user?.role || "") === "cashier" || (user?.role || "") === "user") && (
                        <>
                          {!showMenuMovil ? (
                            <IoMenu size={40} className="cursor-pointer" onClick={() => setShowMenuMovil(true)} />
                          ) : (
                            <IoClose size={40} className="cursor-pointer" onClick={() => setShowMenuMovil(false)} />
                          )}
                        </>
                      )}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        )}
        <div className="relative h-20 w-full"></div>
      </div>

      {showNotificationUser && <NotificationUserBody close={() => setShowNotificationUser(false)} />}
      {showNotificationAdmin && <NotificationAdminBody close={() => setShowNotificationAdmin(false)} />}
    </>
  );
};

export default NavUser;
